import { render, staticRenderFns } from "./MplsL2tpLink.vue?vue&type=template&id=40b67446&"
import script from "./MplsL2tpLink.vue?vue&type=script&lang=js&"
export * from "./MplsL2tpLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports